<template>
    <RouterView v-slot="{ Component, route }">
        <component
            :is="Component"
            v-if="route.meta?.fullscreen"
        />
        <AuthenticatedLayout v-else>
            <component :is="Component" />
        </AuthenticatedLayout>
    </RouterView>
    <ToastNotification
        v-if="showLayout"
        class="z-50"
    />
    <!-- Teleported to <body>: HeadlessUI's Dialog (MuvalModal) marks #app `inert` while a
         modal is open, which stacks the modal over any toast inside #app and swallows the
         pointer events — so hovering a toast (which pauses its dismiss timer) was dead
         exactly when the long guard-error toasts appear. Outside #app the toaster escapes
         the inert and its own z-index paints it above the dialog layer.
         8s duration over the 4s default: guard/error toasts carry multi-sentence messages. -->
    <Teleport to="body">
        <Toaster
            position="bottom-left"
            :duration="8000"
        />
    </Teleport>
    <SelectTenantModal />
</template>
<script setup>
import { Toaster } from 'vue-sonner';
import { useObi } from './composables/useObi';
import { useStaffAssignmentRealtime } from './composables/useStaffAssignmentRealtime';

const appStore = useAppStore();
const userStore = useUserStore();
const diaryStore = useDiaryStore();
const route = useRoute();

// Per-user staff-assignment notifications (CU-86d2dcc7y): one Echo subscription
// for the whole session so assignment toasts + task cache refreshes arrive on
// any page. Subscribes/unsubscribes reactively as the auth user changes.
useStaffAssignmentRealtime({ userStore, diaryStore });

const showLayout = computed(() => {
    return (
        userStore.isAuthenticated &&
        route.name !== 'Login' &&
        route.name !== 'Register' &&
        route.name !== 'Update your preferences'
    );
});

onMounted(async () => {
    appStore.setDeviceType();
    await appStore.initGoogle();
});

useObi();
</script>
<style>
/* Scrollbar hidden by default, visible on hover */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

:hover::-webkit-scrollbar-thumb {
    background: #c4c4c4;
}

:hover::-webkit-scrollbar-thumb:hover {
    background: #868686;
}

/* Firefox */
* {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
}

*:hover {
    scrollbar-color: #c4c4c4 transparent;
}
</style>
